<template>
  <section class="popup-banner-editor">
    <div class="image-uploader">
      <img class="image img-fluid mb-4" :src="thumbnailUrl" />
      <sc-button class="w-100" @click="handleClickChooseImageButton"
        >อัพโหลดรูปภาพ</sc-button
      >
    </div>
    <div class="detail">
      <div class="mb-4">
        <div class="label">ชื่อ</div>
        <el-input v-model="title"></el-input>
      </div>
      <div class="mb-4">
        <div class="label">ช่วงเวลาแสดงผล</div>
        <date-picker
          type="daterange"
          rangeSeparator="ถึง"
          v-model="publishDate"
        ></date-picker>
      </div>
      <div class="mb-4">
        <div class="label">Web URL</div>
        <el-input v-model="webUrl"></el-input>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseImageDialog"
      @cancel="handleCancelChooseImageDialog"
      @confirm="handleConfirmChooseImageDialog"
    ></image-picker-modal>
  </section>
</template>

<script>
import { Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import DatePicker from "@/lib/components/DatePicker";
import ImagePickerModal from "@/lib/components/ImagePickerModal";

export default {
  components: {
    ScButton,
    "el-input": Input,
    DatePicker,
    ImagePickerModal
  },
  props: ["value", "disabled", "imageUrl"],
  data() {
    return {
      isShowModal: false,
      fileThumbnailUrl: null
    };
  },
  watch: {
    value(val, oldVal) {
      if (val.imageFile === oldVal.imageFile) {
        return;
      }

      this.fileThumbnailUrl = URL.createObjectURL(val.imageFile);
    }
  },
  computed: {
    chooseImageDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: !this.disabled,
        title: "เลือกรูป",
        width: 350,
        height: 500,
        recommendWidth: 700,
        recommendHeight: 1000,
        thumbnailFile: this.value.imageFile,
        thumbnailUrl: this.thumbnailUrl
      };
    },
    thumbnailUrl() {
      return (
        this.fileThumbnailUrl ||
        this.imageUrl ||
        "https://placehold.co/700x1000"
      );
    },
    title: {
      get() {
        return this.value.title;
      },
      set(title) {
        this.$emit("input", { ...this.value, title });
      }
    },
    webUrl: {
      get() {
        return this.value.webUrl;
      },
      set(webUrl) {
        this.$emit("input", { ...this.value, webUrl });
      }
    },
    publishDate: {
      get() {
        return this.value.publishDate;
      },
      set(publishDate) {
        this.$emit("input", { ...this.value, publishDate });
      }
    }
  },
  methods: {
    handleCancelChooseImageDialog() {
      this.isShowModal = false;
    },
    handleConfirmChooseImageDialog(file) {
      this.$emit("input", { ...this.value, imageFile: file });
      this.isShowModal = false;
    },
    handleClickChooseImageButton() {
      this.isShowModal = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.popup-banner-editor {
  display: grid;
  grid-gap: 30px;
  grid-template-columns: 350px 1fr;

  .image {
    border: $border;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/communications/modules/popupBanner/components/PopupBannerEditor.vue